import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTrash = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<clipPath id="a"><path d="M0 0h32v32H0z" /></clipPath><g clipPath="url(#a)"><path fill="currentColor" d="M13.714 25.143V11.429H11.43v13.714zm6.857 0V11.429h-2.285v13.714zM24 4.57h8v2.286H0V4.571h8L12.571 0h6.858zm-12.762 0h9.524l-2.286-2.285h-4.952zm14.095 25.143 1.715-20.571h2.285L27.43 32H4.57L2.667 9.143h2.285l1.715 20.571z" /></g></svg>;
export default SvgTrash;